// extracted by mini-css-extract-plugin
export var divider = "_vy-0";